import React, { createContext, useContext, useMemo, useState, useCallback } from "react";
import { dict } from "@/i18n";

const LangContext = createContext({ lang: "es", t: dict.es, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState("es");
  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "es"), []);
  const value = useMemo(() => ({ lang, setLang, t: dict[lang] }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
